import { createContext, useContext } from "react";
import { CountryVersion } from "@smile2impress/attraction-constants";
import { ActiveCity } from "providers/LocationProvider";

type ContextProps = {
    version: CountryVersion;
    city: ActiveCity | null;
    timezone: string | null;
};

export const LocationContext = createContext<ContextProps>({
    version: CountryVersion.SPAIN,
    city: null,
    timezone: null,
});

export const useLocationContext = () => useContext(LocationContext);
